import angular from 'angular';
import { MeurhBeneficiosAlertaController } from './beneficios.alerta.controller';

export class MeurhBeneficiosAlertaComponent implements angular.IComponentOptions {
    static selector = 'meurhBeneficiosAlertaComponent';
    static controller = MeurhBeneficiosAlertaController;
    static template = require('!!html-loader!./beneficios.alerta.html');
    static transclude = true;
    static bindings = {
        entity: '<',
        busy: '='
    };
}
